import React, { useEffect, useState } from 'react';
import {
  Tr,
  Td,
  Flex,
  Text,
  Icon,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';

import { flexRender } from '@tanstack/react-table';
import { FaEye } from 'react-icons/fa';
import '../components/Tables/components/modal.css';
import { useNavigate } from 'react-router-dom';

function TablesTransactionRow(props) {
  const { row } = props;
  const textColor = useColorModeValue('gray.700', 'white');
  const [details, setDetails] = useState(true);
  const navigate = useNavigate();

  let cells = row.getVisibleCells();

  const navigateToDetails = id => {
    if (details) {
      setDetails(false);
      navigate(`/admin_area/transactions/${id}`, { replace: false });
    }
  };

  useEffect(() => {
    document.body.style.overflowY = 'hidden';
    return () => {
      document.body.style.overflowY = 'scroll';
    };
  }, []);

  return (
    <>
      <Tr>
        {/*STARTED*/}
        <Td key={cells[0].id} pl="0px">
          <Flex alignItems="center" minWidth="100%">
            <Text pl={'25px'} fontSize="sm" fontWeight="bold" color={textColor}>
              {cells[0].getContext().row.original.started.slice(0, -8)}
            </Text>
          </Flex>
        </Td>
        {/*ID*/}
        <Td key={cells[1].id}>
          <Text fontSize="sm" fontWeight="bold" color={textColor}>
            {flexRender(cells[1].column.columnDef.cell, cells[1].getContext())}
          </Text>
        </Td>
        {/*STATUS*/}
        <Td key={cells[2].id}>
          <Text fontSize="sm" fontWeight="bold" color={textColor}>
            {flexRender(cells[2].column.columnDef.cell, cells[2].getContext())}
          </Text>
        </Td>
        {/*AMOUNT*/}
        <Td key={cells[3].id}>
          <Text fontSize="sm" fontWeight="bold" color={textColor}>
            {flexRender(cells[3].column.columnDef.cell, cells[3].getContext())}
          </Text>
        </Td>
        {/*ENV*/}
        <Td key={cells[4].id} minWidth={{ sm: '5px' }}>
          <Text fontSize="sm" fontWeight="bold" color="teal.300">
            {flexRender(cells[4].column.columnDef.cell, cells[4].getContext())}
          </Text>
        </Td>
        <Td minWidth={{ sm: '5px' }}>
          <Button
            p="0px"
            bg="transparent"
            onClick={() => {
              navigateToDetails(cells[2].getContext().row.original.id);
              setDetails(true);
            }}
          >
            <Icon as={FaEye} color="gray.400" cursor="pointer" />
          </Button>
        </Td>
      </Tr>
    </>
  );
}

export default TablesTransactionRow;
